export default __webpack_public_path__ + "static/media/Brightness.c789bbe3.svg";